import type {
    QueryChartInteractionDatapoint,
    QueryChartInteractionDatapointMultiSelect,
    MultipleQueryChartInteractionDatapoints,
} from '@bayer-int/portletce-aclibv2';

export type {
    QueryChartInteractionDatapoint,
    QueryChartInteractionDatapointMultiSelect,
    MultipleQueryChartInteractionDatapoints,
};

/**
 * Q: why is this not defined inside aclibv2, where the original `QueryChartInteractionDatapoint` is defined?
 * A: because it would make us import aclibv2 into the main bundle of the portlet, which we want to avoid.
 *    Alternatively, we could move that definition to `shared`.
 */
export const QueryChartInteractionDatapointUtil = {
    toMultiSelect: (
        item: QueryChartInteractionDatapoint | QueryChartInteractionDatapointMultiSelect,
    ): QueryChartInteractionDatapointMultiSelect =>
        QueryChartInteractionDatapointUtil.isMultiselect(item)
            ? item
            : {
                  columnKey: item.columnKey,
                  columnText: item.columnText,
                  items: [item],
              },

    isMultiselect: (
        item: QueryChartInteractionDatapoint | QueryChartInteractionDatapointMultiSelect,
    ): item is QueryChartInteractionDatapointMultiSelect => 'items' in item,

    groupByColumn: (
        datapoints: MultipleQueryChartInteractionDatapoints,
    ): Record<
        QueryChartInteractionDatapoint['columnKey'],
        QueryChartInteractionDatapointMultiSelect
    > => {
        return datapoints.reduce((acc, datapoint) => {
            acc[datapoint.columnKey] = acc[datapoint.columnKey] || {
                columnKey: datapoint.columnKey,
                columnText: datapoint.columnText,
                items: [],
            };
            acc[datapoint.columnKey].items.push(datapoint);
            return acc;
        }, {} as Record<QueryChartInteractionDatapoint['columnKey'], QueryChartInteractionDatapointMultiSelect>);
    },
};
